export default __webpack_public_path__ + "static/media/Treatment_SPRING_LIFT_200_R.e0f31b03.png";